import React from "react";
import { Card, Result, Button } from "antd";
import { BankOutlined } from "@ant-design/icons";


const BankStatements = () => {
    return (
        <div style={{ padding: "24px" }}>
            <Card>
                <Result
                    icon={<BankOutlined style={{ fontSize: 64, color: "#1890ff" }} />}
                    title="Bank Statements"
                    subTitle="Upload and manage bank statements. This feature is available in the admin panel."
                    extra={
                        <Button
                            type="primary"
                            onClick={() => window.open('/admin/accounting/bankstatement/', '_blank')}
                        >
                            Go to Admin Panel
                        </Button>
                    }
                />
            </Card>
        </div>
    );
};

export default BankStatements;
